import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";

import useKrpano from "react-krpano-hooks";
import {
    pageContext,
    programmeNameContext,
    programmeContext,
    lotContext,
    domain,
} from "./../../../contexts";
import ButtonLong from "../../../components/button/buttonLong";
import Annotation from "../../../components/annotation/annotation";

const Vues = () => {
    const { lotParam } = useParams();
    const programmeName = useContext(programmeNameContext);
    const contextDatas = useContext(programmeContext);

    const { lotDatas, setLotDatas } = useContext(lotContext);
    const { setCurrent, setHeaderLevel } = useContext(pageContext);

    const [currentVim, setCurrentVim] = useState(null);
    const [annotationText, setAnnotationText] = useState("");

    const { containerRef, krpanoState } = useKrpano({
        scriptPath: `/public/programmes/${programmeName}/lots/${lotParam}/altimetrie/tour.js`,
        embeddingParams: {
            swf: `/public/programmes/${programmeName}/lots/${lotParam}/altimetrie/tour.swf`,
            xml: `/public/programmes/${programmeName}/lots/${lotParam}/altimetrie/tour.xml`,
            target: "react-krpano",
            html: "prefer",
        },
        width: "calc(100% - 100px)",
    });

    /* -------------------------- fetch lot ------------------------------ */
    useEffect(() => {
        if (programmeName && lotParam) {
            fetch(`${domain}/${programmeName}/lot/name=${lotParam}`, { mode: "cors" })
                .then((r) => r.json())
                .then((d) => setLotDatas(d[lotParam]))
                .catch((e) => console.error("Erreur de fetch lot:", e));
        }
    }, [programmeName, lotParam]);

    useEffect(() => {
        if (programmeName) {
            setCurrent(`detail-lot/${lotParam}/vue`);
            setHeaderLevel(2);
        }
    }, [programmeName, lotParam]);

    useEffect(() => {
        fetch(`${domain}/${programmeName}/lots`, { mode: "cors" })
            .then((r) => r.json())
            .then((d) => setAnnotationText(d.infos.pageVue.annotationText))
            .catch((e) => console.error("Erreur de fetch:", e));
    }, []);

    useEffect(() => setCurrentVim(null), [lotParam]);

    /* ----------------------- utils / limites --------------------------- */
    const defaultRange = {
        xStart: 0,
        yStart: 0,
        xMin: -180,
        xMax: 180,
        yMin: -90,
        yMax: 90,
    };

    const imposeLimits = (kr, vim = defaultRange) => {
        kr.set("view.fov", 70);
        kr.set("view.fovmin", 40);
        kr.set("view.fovmax", 120);
        kr.set("view.limitview", "range");
        kr.set("view.hlookat", vim.xStart);
        kr.set("view.vlookat", vim.yStart);
        kr.set("view.hlookatmin", vim.xMin);
        kr.set("view.hlookatmax", vim.xMax);
        kr.set("view.vlookatmin", vim.yMin);
        kr.set("view.vlookatmax", vim.yMax);

        kr.set("skin_settings.fovmin", 40);
        kr.set("skin_settings.fovmax", 120);
        kr.call("skin_update_controlbar();");

        console.log(`[imposeLimits] fov=70 fovmin=40 fovmax=120 limites appliquées`);
    };

    const maybeApplyLimits = (kr, vim) => {
        const fov = parseFloat(kr.get("view.fov"));
        const fovmin = parseFloat(kr.get("view.fovmin"));
        const fovmax = parseFloat(kr.get("view.fovmax"));

        console.log("[maybeApplyLimits] fov =", fov, "fovmin =", fovmin, "fovmax =", fovmax);

        if (fov !== 70 && fovmin <= 1 && fovmax >= 170) {
            imposeLimits(kr, vim);
        } else {
            console.log("[maybeApplyLimits] scène semble avoir un view personnalisé → on ne touche pas");
        }

    };


    /* ----------------------- charger pano -------------------------- */
    useEffect(() => {
        if (!krpanoState.isEmbedded) return;
        const kr = containerRef.current?.children[0];
        if (!kr) return;

        const newXml = `/public/programmes/${programmeName}/lots/${lotParam}/altimetrie/tour.xml`;

        kr.set("skin_settings.loadscene_flags", "MERGE|KEEPVIEW");
        kr.call(`loadpano('${newXml}', null, MERGE|KEEPVIEW, BLEND(0.5));`);

        kr.set("events.onloadcomplete", () => {
            const vim = currentVim && lotDatas?.altimetries?.[currentVim];
            maybeApplyLimits(kr, vim || defaultRange);
        });
    }, [lotParam, programmeName, krpanoState.isEmbedded]);

    /* ----------------------- changer d'altimétrie ------------------------- */
    useEffect(() => {
        if (!krpanoState.isEmbedded || !lotDatas?.altimetries || !currentVim) return;
        const kr = containerRef.current?.children[0];
        const vim = lotDatas.altimetries[currentVim];
        if (!kr || !vim) return;

        kr.call(`loadscene('scene_alti${vim.id}', null, MERGE|KEEPVIEW, BLEND(0.5));`);
        kr.set("events.onloadcomplete", () => maybeApplyLimits(kr, vim));
    }, [krpanoState.isEmbedded, lotDatas, currentVim]);

    /* ------------------------------ render ---------------------------- */
    return (
        <div id="vues">
            {lotDatas?.altimetries && Object.keys(lotDatas.altimetries).length > 1 && (
                <div id="vuesControllers">
                    {Object.keys(lotDatas.altimetries).map((k) => (
                        <ButtonLong key={k} text={k} state={currentVim === k ? k : ""} action={() => setCurrentVim(k)} />
                    ))}
                </div>
            )}
            <div key={lotParam} ref={containerRef} style={{ position: "absolute", width: "100%", height: "100%" }} />
            {annotationText && <Annotation text={annotationText} leftoffset={50} />}
        </div>
    );
};

export default Vues;
